function Footer()
{
    return(
        <div>
         <div className="bg-[#232F3E] text-white flex px-32 py-10 ">
         <div>
           <p className="text-white font-semibold">Get to know</p>
           <p className="text-white font-semibold">Us</p>
            <p className="text-gray-200 text-sm hover:underline py-1">About Amazon</p>
            <p  className="text-gray-200 text-sm hover:underline py-1">Careers</p>
            <p  className="text-gray-200 text-sm hover:underline py-1">Press Release</p>
            <p  className="text-gray-200 text-sm hover:underline py-1">Amazon Service</p>
           </div>

           <div className="px-20">
           <p className="text-white font-semibold">Connect With</p>
           <p className="text-white font-semibold">Us</p>
            <p  className="text-gray-200 text-sm hover:underline py-1">Facebook</p>
            <p  className="text-gray-200 text-sm hover:underline py-1">Twitter</p>
            <p  className="text-gray-200 text-sm hover:underline py-1">Instagram</p>
           </div>

           <div className="px-10">
         <p className="text-white font-semibold">  Make Money with Us</p>
         <p  className="text-gray-200 text-sm hover:underline py-1">  Sell on Amazon</p>
         <p  className="text-gray-200 text-sm hover:underline py-1"> Sell under Amazon Accelerator</p>
         <p  className="text-gray-200 text-sm hover:underline py-1">  Protect and Build Your Brand</p>
         <p  className="text-gray-200 text-sm hover:underline py-1">  Amazon Global Selling</p>
         <p  className="text-gray-200 text-sm hover:underline py-1">  Supply to Amazon</p>
         <p  className="text-gray-200 text-sm hover:underline py-1">  Become an Affiliate</p>
         <p  className="text-gray-200 text-sm hover:underline py-1"> Fulfilment by Amazon</p>
         <p  className="text-gray-200 text-sm hover:underline py-1"> Advertise Your Products</p>
         <p  className="text-gray-200 text-sm hover:underline py-1"> Amazon Pay on Merchants</p>
         </div>

         <div className="px-10">
         <p className="text-white font-semibold"> Let Us Help You</p>
         <p  className="text-gray-200 text-sm hover:underline py-1"> Your Account</p>
         <p  className="text-gray-200 text-sm hover:underline py-1">Returns Centre</p>
         <p  className="text-gray-200 text-sm hover:underline py-1">Recalls and Product Safety Alerts</p>
         <p  className="text-gray-200 text-sm hover:underline py-1">100% Purchase Protection</p>
         <p  className="text-gray-200 text-sm hover:underline py-1">Amazon App Download</p>
         <p  className="text-gray-200 text-sm hover:underline py-1">Help</p>
         </div>
           </div>

           <div className="bg-black text-gray-200 text-sm text-center py-10 ">
           <p > <span className="hover:underline">Conditions of Use & Sale</span> <span className="hover:underline">Privacy Notice </span><span className="hover:underline"> Interest-Based Ads</span></p>
             <p>© 1996-2024, Amazon.com, Inc. or its affiliates</p>
             </div>

           </div>

        
    )
}
export default Footer